import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Posts from './components/posts';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Posts />} />
            </Routes>
        </Router>
    );
}

export default App;
